<script lang="ts">
  import ControlGroup from '../../../../../components/control-group/ControlGroup.svelte'
  import ControlGroupContent from '../../../../../components/control-group/ControlGroupContent.svelte'
  import { CircleIcon, MinusIcon } from '@lucide/svelte'
  import { ToggleGroup, ToggleGroupItem } from '../../../../../components/toggle-group'
  import { HalfAreaIcon } from '../../../../../components/icons'
  import i18n from '../../../../../i18n'
  import InputLabel from '../InputLabel.svelte'

  let {
    areaType: value = $bindable(),
    hideHalf = false,
    hideFull = false,
  } = $props()
</script>

<ControlGroup>
  <InputLabel>
    {$i18n.t('project.rightBar.zoneSettings.area.title')}
  </InputLabel>
  <ControlGroupContent>
    <ToggleGroup name="area" type="single" bind:value>
      <ToggleGroupItem
        title={$i18n.t('project.rightBar.zoneSettings.area.none')}
        value="none"
      >
        <MinusIcon size="1rem" />
      </ToggleGroupItem>
      {#if !hideHalf}
        <ToggleGroupItem
          title={$i18n.t('project.rightBar.zoneSettings.area.half')}
          value="half"
        >
          <HalfAreaIcon />
        </ToggleGroupItem>
      {/if}
      {#if !hideFull}
        <ToggleGroupItem
          title={$i18n.t('project.rightBar.zoneSettings.area.full')}
          value="full"
        >
          <CircleIcon size="1rem" />
        </ToggleGroupItem>
      {/if}
    </ToggleGroup>
  </ControlGroupContent>
</ControlGroup>
